import type { DragEvent } from "react";

import { DropArea, useDropFiles, useDropTitle } from "@/agent/chat";

import { setLipDrag, setLipOpen, useLipDrag } from "./lipStore";

const allowCopy = (event: DragEvent) => {
  event.preventDefault();
  event.dataTransfer.dropEffect = "copy";
};

/**
 * The lip risen under a drag (02a-over): a layer over its visible top, bar included, so a drop
 * anywhere on it adds the files to the thread's message, as the open card's drop area does, and
 * opens the lip so the chips show. Mount it inside the lip's AgentRuntime, only while risen.
 */
export function LipDropCard() {
  const kind = useLipDrag()?.kind ?? "files";
  const title = useDropTitle(kind);
  const dropFiles = useDropFiles();

  const drop = (event: DragEvent) => {
    event.preventDefault();
    dropFiles(kind, event.dataTransfer);
    setLipDrag(null);
    setLipOpen(true);
  };

  return (
    <div
      data-lip-drop-card=""
      onDragEnter={allowCopy}
      onDragOver={allowCopy}
      onDrop={drop}
      className="absolute inset-x-0 top-0 z-10 flex h-[var(--assistant-lip-drop)] flex-col px-3 pb-3 pt-[var(--assistant-lip-peek)]"
    >
      <DropArea className="flex-1 border-primary/50 bg-primary/5 font-semibold">{title}</DropArea>
    </div>
  );
}
